import { PROFILE_SHORTS_FEED_URL } from "./endpoints";

export const myProfileShortsFeed = async (
  page: number = 1,
  size: number = 10
) => {
  try {
    const apiURL = `${PROFILE_SHORTS_FEED_URL}?page=${page}&size=${size}`;

    const response = await fetch(apiURL, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data.response;
  } catch (error: any) {
    console.error("Error fetching Shorts Feed :", error.message);
    return null;
  }
};
